import { RiShieldUserLine } from 'react-icons/ri';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import SendIcon from '@mui/icons-material/Send';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { AiOutlineCalendar } from 'react-icons/ai';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import EqualizerOutlinedIcon from '@mui/icons-material/EqualizerOutlined';
import { tournamentAddon } from '@projectK/constants/AppEnums';
import { Capacitor } from '@capacitor/core';
import {
  isAdmin,
  isCoach,
  isParent,
  isStudent,
  isSuperAdmin,
  isTournamentCoach,
} from '@projectK/context/RolesProvider';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
 
const isMobile =
  Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios';
const createRoute = ({
  id,
  title,
  messageId,
  url,
  children = null,
  type = null,
  url1 = null,
  url2 = null,
  icon = null,
  permissionKey,
}) => ({
  id,
  title,
  messageId,
  type,
  url,
  url1,
  url2,
  children,
  icon,
  permissionKey,
});
 
const verbiageData = JSON.parse(localStorage.getItem('verbiageSettings')) || {};
 
const adminCommonRoutes = () => [
  {
    id: 'dashboard',
    title: 'Dashboard',
    messageId: 'Dashboard',
    type: 'item',
    icon: <DashboardIcon />,
    url: '/dashboard',
  },
  createRoute({
    id: 'memberInfo',
    title: 'memberInfo',
    messageId: 'Members',
    url: '/admin/credit-wallets',
    type: 'collapse',
    icon: <RiShieldUserLine />,
    children: [
      createRoute({
        id: 'Manage users',
        title: 'Users',
        messageId: 'sidebar.pages.userList',
        url: '/admin/users',
        type: 'item',
        permissionKey: 'Member Information - Member Search',
      }),
      createRoute({
        id: 'credit summary',
        title: 'Credit Summary',
        messageId: 'sidebar.customerAdmin.creditSummary',
        url: '/admin/credit-wallets',
        type: 'item',
        permissionKey: 'Member Information - Credits Overview',
      }),
 
      createRoute({
        id: 'attendance',
        title: 'Attendance',
        messageId: 'sidebar.customerAdmin.AttendanceReport',
        url: '/admin/attendance',
        type: 'item',
        permissionKey: 'Member Information - Attendance Report',
      }),
      createRoute({
        id: 'mergedAccounts',
        title: 'Merged Accounts',
        messageId: 'sidebar.customerAdmin.MergedAccounts',
        url: '/admin/merged-accounts',
        type: 'item',
        permissionKey: 'Member Information - Merged Accounts',
      }),
    ],
  }),
  createRoute({
    id: 'productSetup',
    title: 'productSetup',
    messageId: `${verbiageData?.product_type || 'Product'} Setup`,
    url: '/admin/product-listing',
    type: 'collapse',
    icon: <Inventory2OutlinedIcon />,
 
    children: [
      createRoute({
        id: 'productListing',
        title: 'Product List',
        messageId: `Manage ${verbiageData?.product_type || 'Products'}`,
        url: '/admin/product-listing',
        type: 'item',
        permissionKey: 'Product Setup - Manage Products',
      }),
      createRoute({
        id: 'productListingPage',
        title: 'Product',
        messageId: `${verbiageData?.product_type || 'Products'}`,
        url: '/admin/products',
        type: 'item',
        permissionKey: 'Product Setup - Products Grid',
      }),
      createRoute({
        id: 'productType',
        title: 'Product Type',
        messageId: `${verbiageData?.product_type || 'Product'} Type`,
        url: '/admin/product-type-settings',
        type: 'item',
        permissionKey: 'Product Setup - Product Type',
      }),
      createRoute({
        id: 'manage activity',
        title: 'Manage Activities',
        messageId: 'sidebar.customerAdmin.manageActivity',
        url: '/admin/activities',
        type: 'collapse',
        children: [
          createRoute({
            id: 'manage activity',
            title: 'Activities',
            messageId: 'Activities',
            url: '/admin/activities',
            type: 'item',
            permissionKey: 'Manage Activities - Activities',
          }),
          createRoute({
            id: 'activities-calendar',
            title: 'Activities Calendar',
            messageId: 'sidebar.customerAdmin.activityschedular',
            url: '/calendar',
            type: 'item',
            permissionKey: 'Activities - Calendar',
          }),
          createRoute({
            id: 'activities-session',
            title: 'Activities Sessions',
            messageId: 'sidebar.customerAdmin.eventSearch',
            url: '/admin/activity-session',
            type: 'item',
            permissionKey: 'Manage Activities - Search Sessions',
          }),
          createRoute({
            id: 'My Waitlist',
            title: 'My Waitlist',
            messageId: 'common.waitlist',
            url: '/admin/my-waitlist',
            type: 'item',
            permissionKey: 'Manage Activities - Waitlist',
          }),
        ],
        url1: '/dashboard',
      }),
      createRoute({
        id: 'manage facility',
        title: 'Manage Facility',
        messageId: 'sidebar.customerAdmin.manageFacilities',
        url: '/admin/location',
        type: 'collapse',
        children: [
          createRoute({
            id: 'location',
            title: 'Location',
            messageId: 'sidebar.admin.manageLocation',
            url: '/admin/location',
            type: 'item',
            permissionKey: 'Manage Facilities - Location',
          }),
          createRoute({
            id: 'resurce',
            title: 'Resource',
            messageId: 'sidebar.admin.manageResource',
            url: '/admin/resource',
            type: 'item',
            permissionKey: 'Manage Facilities - Resource',
          }),
        ],
        url1: '/admin/resource',
      }),
      createRoute({
        id: 'packages',
        title: 'Package List',
        messageId: `${verbiageData?.product_type || 'Product'} Packages`,
        url: '/admin/packages',
        type: 'item',
        permissionKey: 'Manage Product Packages',
      }),
      createRoute({
        id: 'Manage Profile Fields',
        title: 'Manage Profile Fields',
        messageId: 'Manage Profile Fields',
        url: '/admin/manage-profileFieids',
        type: 'item',
        permissionKey: 'Manage Product Profile Fields',
      }),
    ],
  }),
  createRoute({
    id: 'report management',
    title: 'Report management',
    messageId: 'sidebar.customerAdmin.reportManagement',
    url: '/admin/reports',
    type: 'collapse',
    icon: <EqualizerOutlinedIcon />,
    children: [
      createRoute({
        id: 'reports',
        title: 'Reports',
        messageId: 'sidebar.admin.reports',
        url: '/admin/reports',
        type: 'item',
        permissionKey: 'Reporting - Reports',
      }),
      createRoute({
        id: 'user reports',
        title: 'user Reports',
        messageId: 'sidebar.customerAdmin.userReport',
        url: '/admin/user-reports',
        type: 'item',
        permissionKey: 'Reporting - User Reports',
      }),
      createRoute({
        id: 'custom report',
        title: 'Custom report Fields',
        messageId: 'sidebar.customerAdmin.customReports',
        url: '/admin/custom-report',
        type: 'item',
        permissionKey: 'Reporting - Custom Reports',
      }),
    ],
  }),
  createRoute({
    id: 'communication',
    title: 'communication',
    messageId: 'sidebar.pages.communication',
    url: '/admin/communication',
    icon: <SendIcon />,
    children: [
      createRoute({
        id: 'communication',
        title: 'communication',
        messageId: 'Send Emails',
        url: '/admin/communication',
        type: 'item',
        permissionKey: 'Communication - Send Emails',
      }),
      createRoute({
        id: 'email_config_settings',
        title: 'Email Config Settings',
        messageId: 'sidebar.admin.emailConfig',
        url: '/admin/settings/email-config',
        type: 'item',
        permissionKey: 'Communication - Email Config',
      }),
      createRoute({
        id: 'email_template_settings',
        title: 'Email Template Settings',
        messageId: 'sidebar.admin.emailTemplateSettings',
        url: '/admin/settings/emailtemplates',
        type: 'item',
        permissionKey: 'Communication - Email Templates',
      }),
      createRoute({
        id: 'email_signature_settings',
        title: 'Email Signature Settings',
        messageId: 'sidebar.admin.emailSignatureSettings',
        url: '/admin/settings/email-signatures',
        type: 'item',
        permissionKey: 'Communication - Email Signatures',
      }),
      createRoute({
        id: 'email_log',
        title: 'Email Log',
        messageId: 'sidebar.admin.emailLog',
        url: '/admin/settings/email-log',
        type: 'item',
        permissionKey: 'Communication - Email Log',
      }),
    ],
    type: 'collapse',
  }),
];

const tournamentRoutes = (hasTournamentAddon) => [
  ...(hasTournamentAddon
    ? [
        createRoute({
          id: 'tournaments',
          title: 'tournaments',
          messageId: 'Tournaments',
          url: '/admin/tournament-listing',
          icon: <EmojiEventsOutlinedIcon />,
          children: [
            createRoute({
              id: 'Tournaments Listing',
              title: 'Tournaments Listing',
              messageId: 'Tournaments Setup',
              url: '/admin/tournament-listing',
              type: 'item',
              permissionKey: 'Tournaments - Tournaments setup',
            }),
            createRoute({
              id: 'active-tournaments',
              title: 'Tournament List',
              messageId: 'sidebar.customerAdmin.tournaments',
              url: '/tournaments',
              type: 'item',
              permissionKey: 'Tournaments - My Tournaments',
            }),
            createRoute({
              id: 'teams',
              title: 'Teams',
              messageId: 'sidebar.customerAdmin.teams',
              url: '/admin/teams',
              type: 'item',
              permissionKey: 'Tournaments - Tournaments teams',
            }),
            createRoute({
              id: 'tournament-verbiage',
              title: 'Tournament settings',
              messageId: 'sidebar.customerAdmin.TournamentVerbiageSettings',
              url: '/admin/tournament-settings',
              type: 'item',
              permissionKey: 'Tournaments - Tournaments setup',
            }),
            createRoute({
              id: 'tournament-google-sheets',
              title: 'Google Sheets',
              messageId: 'sidebar.customerAdmin.tournamentGoogleSheets',
              url: '/admin/tournament-google-sheets',
              type: 'item',
              permissionKey: 'Tournaments - Google Sheets',
            }),
          ],
          type: 'collapse',
        }),
      ]
    : []),
];

const SuperAdminRoutes = (hasTournamentAddon) => [
  ...adminCommonRoutes(),
  {
    id: 'accounting',
    title: 'accounting',
    messageId: 'sidebar.customerAdmin.Accounting',
    type: 'collapse',
    url: '/accounting',
    icon: <AccountBalanceIcon />,
    children: [
      {
        id: 'productbased',
        title: 'Product Based Income',
        messageId: `${verbiageData?.product_type || 'Product'} Based Income`,
        type: 'item',
        url: '/accounting',
        permissionKey: 'Accounting - Product Based Income',
      },
      {
        id: 'product purcase options',
        title: 'Product Purcase Options',
        messageId: 'sidebar.customerAdmin.purchaseOptionBased',
        type: 'item',
        url: '/purchase-option',
        permissionKey: 'Accounting - Purchase Option Based Income',
      },
      {
        id: 'paymentsummary',
        title: 'Payment Summary',
        messageId: 'sidebar.paymentSummaryDetails',
        type: 'item',
        url: '/payment-summary',
        permissionKey: 'Accounting - Payment Summary',
      },
      {
        id: 'manageOrders',
        title: 'Manage Orders',
        messageId: 'sidebar.customerAdmin.manageOrders',
        type: 'item',
        url: '/admin/manage-orders',
        permissionKey: 'Manage Orders',
      },
      {
        id: 'managePayments',
        title: 'Manage Payments',
        messageId: 'sidebar.customerAdmin.manageProducts',
        type: 'item',
        url: '/payment-details',
        permissionKey: 'Accounting - All Payments',
      },
      {
        id: 'manageAllSubscriptions',
        title: 'Manage Subscriptions',
        messageId: 'sidebar.customerAdmin.manageSubscriptions',
        type: 'item',
        url: '/subscriptions',
        permissionKey: 'Accounting - Manage Subscriptions',
      },
      {
        id: 'manageMissedPayments',
        title: 'Missed Payments',
        messageId: `Missed Payments`,
        type: 'item',
        url: '/missed-payments',
        permissionKey: 'Accounting - Missed Payments',
      },
    ],
  },
  ...tournamentRoutes(hasTournamentAddon),
];
 
const generateUserRoutes = (rolePrefix) => {
  const routes = [
    {
      id: 'dashboard',
      title: 'Dashboard',
      messageId: 'Dashboard',
      type: 'item',
      icon: <DashboardIcon />,
      url: '/dashboard',
    },
  ];
  if (rolePrefix === 'parent') {
    if (isMobile) {
    routes.push(
      createRoute({
        id: 'account',
        title: 'My Account Page',
        messageId: 'student.account',
        url: `/${rolePrefix}/my-account`,
        type: 'item',
        icon: <RiShieldUserLine />,
        permissionKey: 'My Locker - Account Info',
      }),
    );
    }
    routes.push(
      createRoute({
        id: 'productListing',
        title: 'Products',
        messageId: `${verbiageData?.product_type || 'Products'}`,
        url: `/${rolePrefix}/product-listing`,
        type: 'item',
        icon: <Inventory2OutlinedIcon />,
        permissionKey: 'Product Setup - Products Grid',
      }),
      createRoute({
        id: 'calender',
        title: 'Scheduler',
        messageId: 'sidebar.apps.calender',
        url: `/${rolePrefix}/activity-calendar`,
        type: 'item',
        icon: <AiOutlineCalendar />,
        permissionKey: 'Activities - Calendar',
      }),
    );
  }
 
  if (rolePrefix !== 'parent') {
      if (isMobile) {
      routes.push(
        createRoute({
          id: 'account',
          title: 'My Account Page',
          messageId: 'student.account',
          url: `/${rolePrefix}/my-account`,
          icon: <RiShieldUserLine />,
          children: [
            createRoute({
              id: 'account',
              title: 'My Account Page',
              messageId: 'student.account',
              url: `/${rolePrefix}/my-account`,
              type: 'item',
              permissionKey: 'My Locker - Account Info',
            }),
            createRoute({
              id: 'settingHistory',
              title: 'Settings History',
              messageId: 'common.ProfileFieldData',
              url: `/${rolePrefix}/profile-data`,
              type: 'item',
              permissionKey: 'Product Profile Info',
            }),
          ],
          type: 'collapse',
        }),
      );
      }
      routes.push(
      createRoute({
        id: 'productListing',
        title: 'Products',
        messageId: `${verbiageData?.product_type || 'Products'}`,
        url: `/${rolePrefix}/product-listing`,
        type: 'item',
        icon: <Inventory2OutlinedIcon />,
        permissionKey: 'Product Setup - Products Grid',
      }),
      createRoute({
        id: 'playerReports',
        title: 'Player Reports',
        messageId: 'sidebar.playerReports',
        url: `/${rolePrefix}/player-reports`,
        type: 'item',
        icon: <DescriptionOutlinedIcon />,
        permissionKey: [
          'Player Reports - Reports',
          'Player Reports - Attendance Summary',
          'Player Reports - Feedback Report',
        ],
      }),
      createRoute({
        id: 'calender',
        title: 'Scheduler',
        messageId: 'sidebar.apps.calender',
        url: `/${rolePrefix}/basic-calendar`,
        type: 'item',
        icon: <AiOutlineCalendar />,
        permissionKey: 'Activities - Calendar',
      }),
    );
  }


  routes.push(
    createRoute({
      id: 'transactionHistory',
      title: 'Transaction History',
      messageId: 'sidebar.transactionHistory',
      url: '/transaction-history',
      type: 'item',
      icon: <ManageHistoryIcon />,
      permissionKey: [
        'Transaction History - My Orders',
        'Transaction History - My Subscription',
        'Transaction History - Credit Overview',
        'Transaction History - Credit History',
        'Transaction History - Card Update History',
      ],
    }),
  );
    if (isMobile) {
      routes.push(
    createRoute({
      id: 'waiversLog',
      title: 'Waivers Log',
      messageId: `${verbiageData?.waiver_name_plural || 'Waivers'} Log`,
      url: `/${rolePrefix}/waivers-log`,
      type: 'item',
      icon: <HistoryOutlinedIcon />,
      permissionKey: 'Product Waivers Log',
    }),
      );
    }


  if (isMobile) {
    routes.push(
      createRoute({
        id: 'events',
        title: 'Events',
        messageId: 'sidebar.mui.dataGrid.events',
        url: `/${rolePrefix}/events`,
        type: 'item',
        permissionKey: 'Manage Activities - Search Sessions',
      }),
    );
    routes.push(
      createRoute({
        id: 'domains',
        title: 'Manage Domains',
        messageId: 'sidebar.mui.dataGrid.domains',
        url: `/${rolePrefix}/domains`,
        type: 'item',
        permissionKey:'My Locker - Account Info'
      }),
    );
    routes.push(
      createRoute({
        id: 'SettingsTab',
        title: 'Settings',
        messageId: 'sidebar.mui.dataGrid.settingsTab',
        url: `/${rolePrefix}/settingsTab`,
        type: 'item',
        permissionKey: 'My Locker - Settings',
      }),
    );
    routes.push(
      createRoute({
        id: 'TransactionHistoryMob',
        title: 'Transaction History',
        messageId: 'sidebar.transactionHistory',
        url: `/transactionHistoryMob`,
        type: 'item',
        permissionKey: [
          'Transaction History - My Orders',
          'Transaction History - My Subscription',
          'Transaction History - Credit Overview',
          'Transaction History - Credit History',
          'Transaction History - Card Update History',
        ],
      }),
    );
  }

  return routes;
};
 
const studentRoutes = generateUserRoutes('student');
const parentRoutes = generateUserRoutes('parent');
 
const generateCoachRoutes = (hasTournamentAddon) => [
  {
    id: 'dashboard',
    title: 'Dashboard',
    messageId: 'Dashboard',
    type: 'item',
    icon: <DashboardIcon />,
    url: '/dashboard',
  },
  {
    id: 'memberInfo',
    title: 'Members',
    messageId: 'Members',
    type: 'collapse',
    icon: <RiShieldUserLine />,
    children: [
      {
        id: 'users',
        title: 'Users',
        messageId: 'sidebar.pages.userList',
        type: 'item',
        url: '/coach/users',
        permissionKey: 'Member Information - Member Search',
      },
      {
        id: 'attendance',
        title: 'Attendance',
        messageId: 'sidebar.customerAdmin.AttendanceReport',
        type: 'item',
        url: '/coach/attendance',
        permissionKey: 'Member Information - Attendance Report',
      },
    ],
  },
  {
    id: 'manageProducts',
    title: 'Manage Products',
    messageId: `${verbiageData?.product_type || 'sidebar.ecommerce.products'}`,
    type: 'collapse',
    icon: <Inventory2OutlinedIcon />,
    children: [
      {
        id: 'activities',
        title: 'Activities List',
        messageId: 'sidebar.customerAdmin.activityListing',
        type: 'item',
        url: '/coach/activities',
        permissionKey: 'Manage Activities - Activities',
      },
      {
        id: 'activitiesCalendar',
        title: 'Activities Calendar',
        messageId: 'sidebar.customerAdmin.activityschedular',
        type: 'item',
        url: '/coach/calendar',
        permissionKey: 'Activities - Calendar',
      },
      {
        id: 'activitiesSession',
        title: 'Activities Sessions',
        messageId: 'sidebar.customerAdmin.eventSearch',
        type: 'item',
        url: '/coach/activity-session',
        permissionKey: 'Manage Activities - Search Sessions',
      },
      {
        id: 'My Waitlist',
        title: 'My Waitlist',
        messageId: 'common.waitlist',
        url: '/coach/my-waitlist',
        type: 'item',
        permissionKey: 'Manage Activities - Waitlist',
      },
      {
        id: 'manageFacility',
        title: 'Manage Facility',
        messageId: 'sidebar.customerAdmin.manageFacilities',
        type: 'collapse',
        url: '/coach/location',
        children: [
          {
            id: 'location',
            title: 'Location',
            messageId: 'sidebar.admin.manageLocation',
            type: 'item',
            url: '/coach/location',
            permissionKey: 'Manage Facilities - Location',
          },
          {
            id: 'resource',
            title: 'Resource',
            messageId: 'sidebar.admin.manageResource',
            type: 'item',
            url: '/coach/resource',
            permissionKey: 'Manage Facilities - Resource',
          },
        ],
      },
    ],
  },
  {
    id: 'reportManagement',
    title: 'Report Management',
    messageId: 'sidebar.customerAdmin.reportManagement',
    type: 'collapse',
    icon: <DescriptionOutlinedIcon />,
    children: [
      {
        id: 'reports',
        title: 'Reports',
        messageId: 'sidebar.admin.reports',
        type: 'item',
        url: '/coach/reports',
        permissionKey: 'Reporting - Reports',
      },
      {
        id: 'userReports',
        title: 'User Reports',
        messageId: 'sidebar.customerAdmin.userReport',
        type: 'item',
        url: '/coach/user-reports',
        permissionKey: 'Reporting - User Reports',
      },
      {
        id: 'communication',
        title: 'Communication',
        messageId: 'sidebar.pages.communication',
        type: 'item',
        url: '/coach/communication',
        permissionKey: 'Communication - Send Emails',
      },
    ],
  },
  ...(hasTournamentAddon
    ? [createRoute({
      id: 'tournaments',
      title: 'tournaments',
      messageId: 'common.tournaments',
      url: '/coach/teams',
      type: 'collapse',
      icon: <EmojiEventsOutlinedIcon />,
      children: [
        createRoute({
          id: 'active-tournaments',
          title: 'Tournament List',
          messageId: 'sidebar.customerAdmin.tournaments',
          url: '/tournaments',
          type: 'item',
          permissionKey: 'Tournaments - My Tournaments',
        }),
        createRoute({
          id: 'teams',
          title: 'Teams',
          messageId: 'sidebar.customerAdmin.teams',
          url: '/coach/teams',
          type: 'item',
          permissionKey: 'Tournaments - Tournaments teams',
        }),
        createRoute({
          id: 'transactionHistory',
          title: 'Transaction History',
          messageId: 'sidebar.transactionHistory',
          url: '/transaction-history',
          type: 'item',
          permissionKey: [
            'Transaction History - My Orders',
            'Transaction History - My Subscription',
            'Transaction History - Credit Overview',
            'Transaction History - Credit History',
            'Transaction History - Card Update History',
          ],
        }),
      ],
    })
  ]
    : []),
];
 
const filterRoutesByPermissions = (routes, rolePermissions) => {
  return routes
    .map((route) => {
      if (route.children) {
        const filteredChildren = filterRoutesByPermissions(
          route.children,
          rolePermissions,
        );
        return filteredChildren.length > 0
          ? { ...route, children: filteredChildren }
          : null;
      }
 
      if (route.permissionKey) {
        if (!rolePermissions || Object.keys(rolePermissions).length === 0) {
          return null;
        }

        // normalize to array
        const keys = Array.isArray(route.permissionKey)
          ? route.permissionKey
          : [route.permissionKey];
 
        const hasPermission = keys.some((key) => {
          const perms = rolePermissions[key.trim()];
          return perms?.includes('read');
        });
 
        return hasPermission ? route : null;
      }
 
      return route;
    })
    .filter(Boolean);
};
 
 
const routesConfig = (userRole, CheckAdddonsSettings, rolePermissions) => {
  if (rolePermissions === null) {
    return []; // or show loading until localStorage is read
  }
  const hasTournamentAddon = CheckAdddonsSettings?.includes(tournamentAddon); // Check if tournament addon exists
 
  let finalRoute = [];
  if (isSuperAdmin(userRole) || isAdmin(userRole)) {
    finalRoute = SuperAdminRoutes(hasTournamentAddon);
  } else if (isCoach(userRole) || isTournamentCoach(userRole)) {
    finalRoute = generateCoachRoutes(hasTournamentAddon);
  } else if (isParent(userRole)) {
    finalRoute = parentRoutes;
  } else if (isStudent(userRole)) {
    finalRoute = studentRoutes;
  }
  const routesMap = finalRoute;
  return filterRoutesByPermissions(routesMap, rolePermissions);
};
 
export default routesConfig;
